import React, { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import debounce from "lodash.debounce"
import { getLoginInfo } from "../users/usersSlice";
import Spinner from "react-bootstrap/Spinner";
import useCurrentUser from '../../hooks/useCurrentUser'
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'

function User({user}){
    console.log(user)

    const statusPost = useApiStatusEnvAwarePost()

    const [barcode,setBarcode] = useState(user.clubready_data?.clubready_barcode)

    const [clubreadyId,setClubreadyId] = useState(user.clubready_data?.clubready_id)

    const [storeId,setStoreId] = useState(user.clubready_data?.clubready_store_id)

    const [status,setStatus] = useState('idle')
    const saveClubreadyData = async ()=>{
        setStatus('pending')
        const res = await statusPost('api/users/',{
            action:'updateMAXClubreadyData',
            fitsw_id:user.user_id_number,
            update:{
                clubready_barcode:barcode,
                clubready_id:clubreadyId,
                clubready_store_id:storeId,
                fitsw_id:user.user_id_number,
            }
        },'clubready data','edit')
        setStatus('idle')
    }

    return (
        <div className="p-2 border rounded mt-2">
            <div className="pb-2 pt-2">
                <i> Name: </i>{user.user_name}
            </div>
            <div className="pb-2 pt-2">
                <i> Email Login: </i>{user.user_id}
            </div>
            <div className="pb-2 pt-2" style={{ overflowWrap: "break-word" }}>
                <i> Password: </i> {user.user_password}
            </div>
            <strong>ClubReady Data</strong>
            <div>
                <small>Store ID</small>
                <Form.Control 
                    value={storeId}
                    onChange={e=>{
                        setStoreId(e.target.value)
                    }}
                    block 
                />
                <small>ClubReady ID</small>
                <Form.Control 
                    value={clubreadyId}
                    onChange={e=>{
                        setClubreadyId(e.target.value)
                    }}
                    block 
                />
                <small>Barcode</small>
                <Form.Control
                    value={barcode}
                    onChange={e=>{
                        setBarcode(e.target.value)
                    }}
                    block
                />
                <Button  
                    disabled={status==='pending'}
                    className="mt-2"
                    block
                    variant="outline-success" 
                    onClick={saveClubreadyData}
                >
                    {status==='pending'
                        ? <Spinner animation="border" size="sm"/>
                        : "Save ClubReady Data"
                }
                </Button>
            </div>
        </div>
    )
}

function AdminDashboard() {
    const dispatch = useDispatch()

    const user = useCurrentUser()

    const [searched, setSearched] = useState("")
    const [userList, setUserList] = useState([])
    const [noResults, setNoResults] = useState(false)
    const [isLoading, setIsLoading] = useState("")

    function searchHashedPassword (searched) {
        clearResults()
        setIsLoading(true);
        dispatch(getLoginInfo({ searched }))
            .then(res => {
                if (res.payload.success == "1") {
                    setNoResults(false);
                    setUserList(res.payload.data);
                    setIsLoading(false);
                } else {
                    setUserList([]);
                    setNoResults(true);
                    setIsLoading(false);
                }
            })
    }

    function clearResults() {
        setUserList([]);
        setNoResults(false);
    }

    function handleSearch(e) {
        setSearched(e.target.value)
        if (e.target.value == "") {
            clearResults();
            return;
        }
        debouncedSearchHashedPassword(e.target.value)
    }


    const debouncedSearchHashedPassword = useCallback(debounce((payload) =>
        searchHashedPassword(payload), 800), [])

    return (
        user.account_type === "chain" &&
        <div className="pt-2 px-2 px-md-3">
            <strong className="d-block mb-1">
                Access User Login Information
            </strong>
            <div className="mt-2"> <i className="fa fa-info-circle mr-1"></i>Search below to get login information for your gym, trainer, or client accounts </div>
            <div className="mt-2">
                <div className="mb-4">
                    <Form.Label> Enter user's full name or email login  </Form.Label>
                    <Form.Control value={searched} onChange={handleSearch} placeholder="type here" />
                </div>
                <div className={`my-4`}>
                    {isLoading ? <Spinner animation="border" /> :
                        <>
                            {userList?.map(user => <User user={user}/>)}

                            {noResults && <div className="ml-3 text-danger"> No Matching Accounts Found </div>}
                        </>}
                </div>
            </div>
        </div>
    )
}

export default AdminDashboard;